import { Button, CloseButton } from '@ui/shared/Button';
import * as React from 'react';
import { ISelectedLabelKey, ITest, Level } from '../../../../data/types';
import { Column } from '../../../layout/Column';
import { Card } from '../../../shared/card/Card';
import { CardBody } from '../../../shared/card/CardBody';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../../shared/card/CardHeader';
import { InnerPopupCard } from '../../../shared/popups/PopupCard';
import { MetricHistory } from './MetricHistory';

interface IProps {
  level: Level;
  onClose: () => void;
  test: ITest;
  metric: ISelectedLabelKey;
}

export const MetricHistoryPopup = (props: IProps): React.ReactElement => {
  const Wrapper = props.level === 2 ? Card : InnerPopupCard;

  return (
    <Wrapper onClose={props.onClose} size='large' noClickOutside>
      <Column>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h6>Metric History</h6>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          <MetricHistory
            test={props.test}
            athlete={props.test.athlete}
            metric={props.metric}
          />
        </CardBody>
      </Column>
    </Wrapper>
  );
};
